import apiClient from './client.js';

export async function fetchPendingReminders() {
  const { data } = await apiClient.get('/reminders/pending');
  return data;
}

export async function fetchLeadReminders(leadId) {
  const { data } = await apiClient.get(`/reminders/lead/${leadId}`);
  return data.reminders;
}

export async function createReminder({ leadId, text, remindAt }) {
  const { data } = await apiClient.post('/reminders', { leadId, text, remindAt });
  return data.reminder;
}

export async function dismissReminder(id) {
  const { data } = await apiClient.delete(`/reminders/${id}`);
  return data;
}
